export { delta as deltaFromArray } from './Delta'
export { areEquals as areArrayEquals } from './Equality'
export { isNotEmpty as isArrayNotEmpty } from './Empty'
export { is as isArray } from './Is'
